// Property data for Villas Pura Vida — three properties
// Brand: Villas Pura Vida (complex) | Properties: La Casita, Loft Pura Brisa, Mini Loft Pura Vida

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const asset = (path) => `${BACKEND}/api/files/${path}`;

export const BRAND = {
  name: "Villas Pura Vida",
  tagline: { es: "Frente al mar — Barra de Galindo, Tuxpan", en: "Beachfront — Barra de Galindo, Tuxpan" },
  location: "Barra de Galindo, Tuxpan, Veracruz",
};

export const PROPERTIES = {
  casita: {
    id: "casita",
    slug: "casita",
    name: "La Casita Pura Vida",
    short_name: "La Casita",
    tagline_es: "Frente al mar | Del alba al atardecer",
    tagline_en: "Beachfront | From dawn to dusk",
    capacity: 14,
    bedrooms: 3,
    beds: 8,
    baths: 2,
    pricing: { airbnb_regular: 3556, airbnb_high: 3911, web_regular: 3200, web_high: 3520 },
    ideal_for_es: "Familias grandes · Grupos de amigos · Celebraciones tranquilas",
    ideal_for_en: "Large families · Groups of friends · Quiet gatherings",
    hero_image:
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/5mzc0tyz_6c580bb7-b105-4086-a8ca-5bc6850ae4d8.jpg",
    card_image:
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/1zw1i3j4_bfade5ce-db82-4802-acc6-9dd885c0b5ef.jpg",
    gallery: [
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/1zw1i3j4_bfade5ce-db82-4802-acc6-9dd885c0b5ef.jpg", span: "md:col-span-8 md:row-span-2", alt: "Playa Barra de Galindo" },
      { url: "https://images.unsplash.com/photo-1711426793021-ae58d127d79c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", span: "md:col-span-4", alt: "Sala amplia" },
      { url: "https://images.unsplash.com/photo-1540541338287-41700207dee6?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", span: "md:col-span-4", alt: "Terraza al amanecer" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/q8kmt15z_b698c33e-488d-4bac-b9e5-cb307bfaef50.jpg", span: "md:col-span-6", alt: "Recorrido por la playa" },
      { url: "https://images.unsplash.com/photo-1518684079-3c830dcef090?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85", span: "md:col-span-6", alt: "Mesa al aire libre" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/9zic33cw_a8ddb780-66a3-4fbe-b8df-ff87c066511a.jpg", span: "md:col-span-8", alt: "Caminando en el mar" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/5mzc0tyz_6c580bb7-b105-4086-a8ca-5bc6850ae4d8.jpg", span: "md:col-span-4", alt: "Atardecer en Barra de Galindo" },
    ],
    experiences_images: [
      "https://images.unsplash.com/photo-1647962431451-d0fdaf1cf21c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/5mzc0tyz_6c580bb7-b105-4086-a8ca-5bc6850ae4d8.jpg",
      "https://images.unsplash.com/photo-1502082553048-f009c37129b9?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/lojfad7u_83fcf2b1-91d6-485d-a1ac-924d5333191c.jpg",
      "https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/9zic33cw_a8ddb780-66a3-4fbe-b8df-ff87c066511a.jpg",
    ],
    features: ["bedrooms", "beds", "baths", "kitchen", "parking", "beach", "view", "living"],
    story: {
      es: {
        title: "Casita Pura Vida es sencilla, auténtica y natural.",
        p1: "Imagina despertar con los primeros rayos del sol iluminando el horizonte mientras el sonido de las olas acompaña tu mañana. Abres la puerta, respiras el aire salado del Golfo de México y recuerdas cómo se siente vivir sin prisas.",
        p2: "Por la mañana, el amanecer pinta el cielo de tonos dorados. Por la tarde, el cielo se transforma con el atardecer y la brisa marina. Por la noche, las estrellas iluminan el cielo y los sonidos de la naturaleza toman protagonismo.",
        p3: "Aquí no vienes a correr de actividad en actividad. Vienes a respirar profundo, a disfrutar el presente y a dejar que el mar haga el resto.",
      },
      en: {
        title: "Casita Pura Vida is simple, authentic and natural.",
        p1: "Imagine waking up to the first rays of sun lighting the horizon while the sound of waves accompanies your morning. You open the door, breathe in the salty Gulf air, and remember what it feels to live unhurried.",
        p2: "By morning, sunrise paints the sky in golden tones. By afternoon, sunset transforms the landscape. By night, stars take over the sky and the sounds of nature become protagonists.",
        p3: "Here you don't rush from activity to activity. You come to breathe deeply, enjoy the present and let the sea do the rest.",
      },
    },
  },

  loft: {
    id: "loft",
    slug: "loft",
    name: "Loft Pura Brisa",
    short_name: "Pura Brisa",
    tagline_es: "Loft frente al mar | Íntimo y luminoso",
    tagline_en: "Beachfront loft | Intimate and bright",
    capacity: 6,
    bedrooms: 1,
    beds: 4,
    baths: 1,
    pricing: { airbnb_regular: 1610, airbnb_high: 1610, web_regular: 1449, web_high: 1449 },
    ideal_for_es: "Parejas · Familias pequeñas · Escapadas de fin de semana",
    ideal_for_en: "Couples · Small families · Weekend getaways",
    hero_image:
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/q8kmt15z_b698c33e-488d-4bac-b9e5-cb307bfaef50.jpg",
    card_image:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-50437584/original/c2281f9e-c293-49c5-957f-62ab7ac8fc2b.jpeg?im_w=1440",
    gallery: [
      { url: "https://a0.muscache.com/im/pictures/hosting/Hosting-50437584/original/c2281f9e-c293-49c5-957f-62ab7ac8fc2b.jpeg?im_w=1440", span: "md:col-span-7 md:row-span-2", alt: "Loft interior con vista" },
      { url: "https://a0.muscache.com/im/pictures/hosting/Hosting-50437584/original/3b731e68-457a-46ae-8015-895b3e35f5a8.jpeg?im_w=1200", span: "md:col-span-5", alt: "Detalle del loft" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/1zw1i3j4_bfade5ce-db82-4802-acc6-9dd885c0b5ef.jpg", span: "md:col-span-5", alt: "Playa frente al loft" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/9zic33cw_a8ddb780-66a3-4fbe-b8df-ff87c066511a.jpg", span: "md:col-span-6", alt: "Olas en Barra de Galindo" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/5mzc0tyz_6c580bb7-b105-4086-a8ca-5bc6850ae4d8.jpg", span: "md:col-span-6", alt: "Atardecer cerca del loft" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/q8kmt15z_b698c33e-488d-4bac-b9e5-cb307bfaef50.jpg", span: "md:col-span-8", alt: "Recorrido por la playa" },
      { url: "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/lojfad7u_83fcf2b1-91d6-485d-a1ac-924d5333191c.jpg", span: "md:col-span-4", alt: "Cangrejo nocturno en la zona" },
    ],
    experiences_images: [
      "https://images.unsplash.com/photo-1647962431451-d0fdaf1cf21c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/5mzc0tyz_6c580bb7-b105-4086-a8ca-5bc6850ae4d8.jpg",
      "https://images.unsplash.com/photo-1473773508845-188df298d2d1?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/lojfad7u_83fcf2b1-91d6-485d-a1ac-924d5333191c.jpg",
      "https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/9zic33cw_a8ddb780-66a3-4fbe-b8df-ff87c066511a.jpg",
    ],
    features: ["bedrooms_1", "beds_4", "baths_1", "kitchen", "parking", "beach", "view", "wifi"],
    story: {
      es: {
        title: "Un loft luminoso, íntimo y con el mar a pocos pasos.",
        p1: "Imagina despertar con el sonido de las olas, preparar un café y caminar unos pasos hasta la playa para contemplar cómo el sol comienza a iluminar el horizonte. Aquí los días transcurren sin prisas.",
        p2: "Diseño abierto, climatizado y cómodo: sala, comedor y cocina equipada integradas en un solo espacio. Perfecto para parejas, familias pequeñas o escapadas de fin de semana.",
        p3: "Brisa marina, aire limpio y la tranquilidad de una playa semivirgen donde la naturaleza aún conserva su esencia.",
      },
      en: {
        title: "A bright, intimate loft with the sea steps away.",
        p1: "Imagine waking up to the sound of waves, brewing a coffee and walking a few steps to the beach to watch the sun light the horizon. Days move unhurried here.",
        p2: "Open, air-conditioned, comfortable design: living, dining and kitchen integrated in a single space. Perfect for couples, small families or weekend escapes.",
        p3: "Sea breeze, clean air, and the calm of a semi-virgin beach where nature still keeps its essence.",
      },
    },
  },

  miniloft: {
    id: "miniloft",
    slug: "miniloft",
    name: "Mini Loft Pura Vida",
    short_name: "Mini Loft",
    tagline_es: "Loft abierto | Playa secreta a unos pasos",
    tagline_en: "Open loft | Secret beach steps away",
    capacity: 6,
    bedrooms: 1,  // studio open-plan — se cuenta como 1 "ambiente" para el huésped
    beds: 4,       // 2 matrimoniales + 2 individuales elevadas
    baths: 1,
    pricing: { airbnb_regular: 1610, airbnb_high: 1610, web_regular: 1449, web_high: 1449 },
    ideal_for_es: "Parejas · Familias con niños pequeños · Amantes de la naturaleza · Escapadas tranquilas",
    ideal_for_en: "Couples · Families with young kids · Nature lovers · Quiet getaways",
    airbnb_url: "https://www.airbnb.mx/h/miniloft-tuxpan",
    // Hero and card now use real Mini Loft photos uploaded to Object Storage.
    // The Hero component auto-fetches `portada[0]` from the DB (seeded via
    // /app/scripts/finalize_miniloft_portada.py — editorial bedroom with
    // sand-colored linen generated with Nano Banana from the real REC-04 shot).
    // The card is pinned to EXT-03 (nocturnal façade) because the user chose
    // deliberate visual variety between the big hero and the villa-list card.
    hero_image: asset("villas-pura-vida/photos/miniloft/hero/rec04-sand-704788b1.jpg"),
    // Card: REC-22 (wide studio view) re-touched via Nano Banana v2 — sand/cream textiles with
    // natural daylight to match the amateur real-estate photo language of Casita + Loft Pura Brisa cards.
    // /app/scripts/generate_miniloft_card_v2.py
    card_image: asset("villas-pura-vida/photos/miniloft/card/rec22-day-96b19810.jpg"),
    card_image_pin: true,
    gallery: [
      { url: asset("villas-pura-vida/photos/miniloft/portada/5128982f-7ce3-4477-8aa9-1c9d40fa4f50.jpeg"), span: "md:col-span-7 md:row-span-2", alt: "Mini Loft Pura Vida — recámara con 4 camas (literas + matrimoniales)" },
      { url: asset("villas-pura-vida/photos/miniloft/portada/704acf65-88b8-4a2e-b53a-6590986450d3.jpeg"), span: "md:col-span-5", alt: "Mini Loft Pura Vida — sala/área común" },
      { url: asset("villas-pura-vida/photos/miniloft/portada/56dd30cc-40d7-4d05-b986-c7f9178bbeea.jpeg"), span: "md:col-span-5", alt: "Mini Loft Pura Vida — cocina equipada" },
      { url: asset("villas-pura-vida/photos/miniloft/portada/452b5108-7bd6-4d84-897f-60ab2e0163f4.jpeg"), span: "md:col-span-6", alt: "Mini Loft Pura Vida — baño con agua caliente" },
      { url: asset("villas-pura-vida/photos/miniloft/portada/26f6503d-6356-416a-bc98-de48ebdd8246.jpeg"), span: "md:col-span-6", alt: "Mini Loft Pura Vida — fachada iluminada al anochecer" },
    ],
    experiences_images: [
      "https://images.unsplash.com/photo-1647962431451-d0fdaf1cf21c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/5mzc0tyz_6c580bb7-b105-4086-a8ca-5bc6850ae4d8.jpg",
      "https://images.unsplash.com/photo-1473773508845-188df298d2d1?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/lojfad7u_83fcf2b1-91d6-485d-a1ac-924d5333191c.jpg",
      "https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
      "https://customer-assets.emergentagent.com/job_playas-veracruz/artifacts/9zic33cw_a8ddb780-66a3-4fbe-b8df-ff87c066511a.jpg",
    ],
    features: ["bedrooms_1", "beds_4", "baths_1", "kitchen", "parking", "beach", "view", "wifi"],
    story: {
      es: {
        title: "Un pequeño refugio frente al mar.",
        p1: "Desconéctate de la rutina y disfruta de una playa tranquila y semivirgen en Tuxpan. Este acogedor Mini Loft es ideal para quienes buscan descansar, despertar con el sonido del mar y disfrutar atardeceres, estrellas y mucha tranquilidad.",
        p2: "No cuenta con una recámara independiente ni paredes que separen las áreas. Todo se encuentra integrado en un mismo espacio: sala, comedor, cocina y área para dormir — 2 camas matrimoniales y 2 individuales elevadas (ideales para niños).",
        p3: "Aquí no vienes por los lujos de un gran hotel, vienes por algo mejor: privacidad, naturaleza y la sensación de tener la playa casi para ti. ✨",
      },
      en: {
        title: "A tiny beachfront refuge.",
        p1: "Disconnect from routine and enjoy a quiet, semi-virgin beach in Tuxpan. This cozy Mini Loft is ideal for anyone looking to rest, wake up to the sound of the sea, and enjoy sunsets, stars and deep stillness.",
        p2: "No separate bedroom, no walls dividing spaces. Everything is integrated: living, dining, kitchen and sleeping area — 2 full beds and 2 elevated singles (perfect for kids).",
        p3: "You don't come here for the luxuries of a big hotel. You come for something better: privacy, nature and the feeling that the beach is almost yours alone. ✨",
      },
    },
  },
};

export const PROPERTY_LIST = [PROPERTIES.casita, PROPERTIES.loft, PROPERTIES.miniloft];
